import React from "react";
import { Line } from "@ant-design/plots";

const MultilineChart = ({ filterType, data }) => {
  // const [multilineChartData, setMultilineChartData] = useState([
  //   // Jan
  //   { type: "Telegram", month: "Jan", value: 100, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Jan", value: 320, color: "#5162F3" },
  //   { type: "Snapchat", month: "Jan", value: 250, color: "#599CE7" },
  //   { type: "A Brand", month: "Jan", value: 150, color: "#EF5020" },
  //   { type: "B Brand", month: "Jan", value: 50, color: "#933519" },
  //   // Feb
  //   { type: "Telegram", month: "Feb", value: 250, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Feb", value: 280, color: "#5162F3" },
  //   { type: "Snapchat", month: "Feb", value: 220, color: "#599CE7" },
  //   { type: "A Brand", month: "Feb", value: 180, color: "#EF5020" },
  //   { type: "B Brand", month: "Feb", value: 75, color: "#933519" },
  //   // Mar
  //   { type: "Telegram", month: "Mar", value: 490, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Mar", value: 410, color: "#5162F3" },
  //   { type: "Snapchat", month: "Mar", value: 410, color: "#599CE7" },
  //   { type: "A Brand", month: "Mar", value: 190, color: "#EF5020" },
  //   { type: "B Brand", month: "Mar", value: 80, color: "#933519" },
  //   // Apr
  //   { type: "Telegram", month: "Apr", value: 450, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Apr", value: 610, color: "#5162F3" },
  //   { type: "Snapchat", month: "Apr", value: 420, color: "#599CE7" },
  //   { type: "A Brand", month: "Apr", value: 290, color: "#EF5020" },
  //   { type: "B Brand", month: "Apr", value: 120, color: "#933519" },
  //   // May
  //   { type: "Telegram", month: "May", value: 690, color: "#1F2EB4" },
  //   { type: "Facebook", month: "May", value: 730, color: "#5162F3" },
  //   { type: "Snapchat", month: "May", value: 720, color: "#599CE7" },
  //   { type: "A Brand", month: "May", value: 420, color: "#EF5020" },
  //   { type: "B Brand", month: "May", value: 160, color: "#933519" },
  //   // Jun
  //   { type: "Telegram", month: "Jun", value: 590, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Jun", value: 620, color: "#5162F3" },
  //   { type: "Snapchat", month: "Jun", value: 700, color: "#599CE7" },
  //   { type: "A Brand", month: "Jun", value: 340, color: "#EF5020" },
  //   { type: "B Brand", month: "Jun", value: 150, color: "#933519" },
  //   // Jul
  //   { type: "Telegram", month: "Jul", value: 510, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Jul", value: 700, color: "#5162F3" },
  //   { type: "Snapchat", month: "Jul", value: 690, color: "#599CE7" },
  //   { type: "A Brand", month: "Jul", value: 290, color: "#EF5020" },
  //   { type: "B Brand", month: "Jul", value: 160, color: "#933519" },
  //   // Aug
  //   { type: "Telegram", month: "Aug", value: 610, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Aug", value: 760, color: "#5162F3" },
  //   { type: "Snapchat", month: "Aug", value: 750, color: "#599CE7" },
  //   { type: "A Brand", month: "Aug", value: 400, color: "#EF5020" },
  //   { type: "B Brand", month: "Aug", value: 180, color: "#933519" },
  //   // Sep
  //   { type: "Telegram", month: "Sep", value: 810, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Sep", value: 790, color: "#5162F3" },
  //   { type: "Snapchat", month: "Sep", value: 800, color: "#599CE7" },
  //   { type: "A Brand", month: "Sep", value: 430, color: "#EF5020" },
  //   { type: "B Brand", month: "Sep", value: 190, color: "#933519" },
  //   // Oct
  //   { type: "Telegram", month: "Oct", value: 710, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Oct", value: 790, color: "#5162F3" },
  //   { type: "Snapchat", month: "Oct", value: 770, color: "#599CE7" },
  //   { type: "A Brand", month: "Oct", value: 420, color: "#EF5020" },
  //   { type: "B Brand", month: "Oct", value: 195, color: "#933519" },
  //   // Nov
  //   { type: "Telegram", month: "Nov", value: 780, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Nov", value: 780, color: "#5162F3" },
  //   { type: "Snapchat", month: "Nov", value: 820, color: "#599CE7" },
  //   { type: "A Brand", month: "Nov", value: 590, color: "#EF5020" },
  //   { type: "B Brand", month: "Nov", value: 196, color: "#933519" },
  //   // Dec
  //   { type: "Telegram", month: "Dec", value: 820, color: "#1F2EB4" },
  //   { type: "Facebook", month: "Dec", value: 910, color: "#5162F3" },
  //   { type: "Snapchat", month: "Dec", value: 890, color: "#599CE7" },
  //   { type: "A Brand", month: "Dec", value: 700, color: "#EF5020" },
  //   { type: "B Brand", month: "Dec", value: 220, color: "#933519" },
  // ]);
  // const data2 = [
  //   { type: "Message In", hour: 21, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 21, value: 0, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 22, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 22, value: 0, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 23, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 23, value: 0, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 0, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 0, value: 2, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 1, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 1, value: 6, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 2, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 2, value: 0, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 3, value: 1, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 3, value: 3, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 4, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 4, value: 1, color: "#599CE7", key: "out" },
  //   { type: "Message In", hour: 5, value: 0, color: "#1F2EB4", key: "in" },
  //   { type: "Message Out", hour: 5, value: 0, color: "#599CE7", key: "out" },
  // ];
  const filterMappings = {
    hour: { xField: "hour", xTickInterval: 1 },
    day: { xField: "day", xTickInterval: 1 },
    month: { xField: "month", xTickInterval: 1 },
    year: { xField: "year", xTickInterval: 1 },
  };

  const { xField, xTickInterval } = filterMappings[filterType] || {};

  // useEffect(() => {
  //   if (isRefresh) {
  //     setMultilineChartData(multilineChartData);
  //   }
  // }, [filterType, isRefresh]);
  // console.log("data", data);
  return (
    <Line
      data={data}
      xField={xField}
      yField={"value"}
      seriesField={"type"}
      color={data.map(item => item.color)}
      smooth={false}
      xAxis={{
        tickInterval: xTickInterval,
        max: 24,
        tickCount: 24,
      }}
      yAxis={{
        nice: true,
        min: 0,
        max: 100,
        tickCount: 10,
      }}
      legend={{
        position: "bottom",
        label: {
          usePointStyle: true,
          pointStyle: "circle",
        },
      }}
      tooltip={{
        showCrosshairs: true,
        crosshairs: {
          type: "x",
        },
      }}
    />
  );
};
export default MultilineChart;
